import React from "react";
import { Routes, Route } from "react-router-dom";

// import Bookings from './Bookings'; // Add your pages as necessary
// import Availability from './Availability'; // Add your pages as necessary
// import Lawyers from './Lawyers'; // Example other page
import CheckoutForm from "./lawyerSelection/checkoutForm";
import Return from "./lawyerSelection/checkout/returnPage";
import Success from "./lawyerSelection/checkout/success";
import IntakeForm from "./lawyerSelection/intakeForm";
import MyAppointments from "./myAppointments/myAppointments";
import ClientProfile from "./clientProfile/clientProfile";
import ClientVideo from "./video/clientVideo";

const ClientRoutes = () => {
  return (
    <Routes>
      <Route path="/checkout" element={<CheckoutForm />} />
      <Route path="/intake-form" element={<IntakeForm />} />
      <Route path="/success" element={<Success />} />
      <Route path="/return" element={<Return />} />
      <Route path="/my-appointments" element={<MyAppointments />} />
      <Route path="/my-profile" element={<ClientProfile />} />
    </Routes>
  );
};

export default ClientRoutes;
